import React, { useState, useEffect } from 'react';
import Header from '../layout/header';
import Footer from '../layout/footer';
import Leftmenu from '../Patients/leftmenu';
import Profiledetail from '../Patients/profiledetail';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { callingAPI } from '../config';
import { toast } from 'react-toastify';

import {
    faAngleRight,
    faPhoneAlt,
} from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';
import NoLabOrderList from '../Common/noLabOrderList';
import Pagination from 'react-js-pagination';
import LabOrderSave from './labOrder';
import Printer_icon from '../images/icons/printer_icon.png';
import Send_icon from '../images/icons/lab/send.png';
import Editicon from '../images/icons/edit-bg.png';
import Datepicker from "react-datepicker";

function LabOrderList() {
    const [clcikFlagActive, setClickFlagActive] = useState(false)
    const [clcikFlagSent, setClickFlagSent] = useState(false)
    const [clcikFlagProduction, setClickFlagProduction] = useState(false)
    const [clcikFlagTransit, setClickFlagTransit] = useState(false)
    const [clcikFlagRecieved, setClickFlagRecieved] = useState(false)
    const [clcikFlagOverdue, setClickFlagOverdue] = useState(false)
    const [clcikFlagDTL, setClickFlagDTL] = useState(false)
    const [clcikFlagRTL, setClickFlagRTL] = useState(false)
    const [clcikFlagToday, setClickFlagToday] = useState(false)
    const [clcikFlagTomorrow, setClickFlagTomorrow] = useState(false)
    const [initialRender, setInitialRender] = useState(true);
    const [inputValue, setInputValue] = useState("")
    const [listArray, setListArray] = useState([])
    const [statusListArray, setStatusListArray] = useState([])
    const [pageCount, setPageCount] = useState('');
    const [activePage, setActivePage] = useState(parseInt(window.sessionStorage.getItem('dentalactivePage')));
    const [componentActivate, setComponentActivate] = useState(false);
    const [editClick, setEditClick] = useState([]);
    const [dateField, setDateField] = useState({});
    const [role, setRole] = useState(window.sessionStorage.getItem("role"));
    const [dropDownCounter, setDropDownCounter] = useState({ "id": "", "count": 0 });
    const [pageOffset, setPageOffset] = useState(0);
    const [selectedDates, setSelectedDates] = React.useState({});
    useEffect(() => {
        labTrackingList();
        statusList();
    }, []);
    const labTrackingList = () => {
        const apiJson = {
            "labOrderId": "",
            "memberId": window.sessionStorage.getItem('memberId'),
            "hospitalId": localStorage.getItem('hospitalId'),
            "doctorId": "",
            "searchInput": "",
            "cmbStatus": "",
            "offset": 0,
            "max": 10,
            "dueDateSelect": "",
        }
        callingAPI("commonUserFunctions/getDentalLabOrderDetails", apiJson).then((data) => {

            if (data?.data?.success === "1") {
                setListArray(data?.data?.result)
                setPageCount(data?.data?.totalCount)
            }
        })
    }
    const statusList = () => {
        const apiJson = {
            "hospitalId": localStorage.getItem('hospitalId'),
        }
        callingAPI("commonUserFunctions/getDentalLabMasterDetails", apiJson).then((data) => {

            if (data.data.success === "1") {
                setStatusListArray(data.data.result.dentalLabStatusDetails)
            }
        })
    }
    const paginationOnChange = (pageNumber) => {

        var offset;
        var max;
        if (pageNumber === '1') {
            offset = '0';
            max = process.env.REACT_APP_PAGINATION_COUNT;
        } else {
            offset = parseInt(pageNumber - 1) * process.env.REACT_APP_PAGINATION_COUNT;
            max = process.env.REACT_APP_PAGINATION_COUNT;
        }
        setActivePage(pageNumber);
        setPageOffset(offset);
        var statusCheckArray = [clcikFlagActive === true ? "1" : "", clcikFlagSent === true ? "2" : "", clcikFlagProduction === true ? "3" : "", clcikFlagTransit === true ? "4" : "", clcikFlagRecieved === true ? "5" : "", clcikFlagOverdue === true ? "6" : ""]
        var statusCheckArrayresult = statusCheckArray.filter(function (value) {
            return value && value !== "";
        }).join(",");
        var dueCheckArray = [clcikFlagToday === true ? "today" : "", clcikFlagTomorrow === true ? "tomarrow" : ""]
        var dueCheckArrayresult = dueCheckArray.filter(function (value) {
            return value && value !== "";
        }).join(",");
        window.sessionStorage.setItem("dentalactivePage", pageNumber)
        window.sessionStorage.setItem('dentaloffset', offset)
        const apiJson = {
            "labOrderId": "",
            "memberId": window.sessionStorage.getItem('memberId'),
            "hospitalId": localStorage.getItem('hospitalId'),
            "doctorId": "",
            "searchInput": inputValue,
            "cmbStatus": statusCheckArrayresult,
            "offset": offset,
            "max": max,
            "dueDateSelect": dueCheckArrayresult,
        }
        callingAPI("commonUserFunctions/getDentalLabOrderDetails", apiJson).then((data) => {

            if (data.data.success === '1') {
                setListArray(data.data.result)
                setPageCount(data.data.totalCount)
            }
            else {
                setListArray(data.data.result)
            }
        });
    };
    useEffect(() => {
        if (initialRender) {
            setInitialRender(false);
        } else {
            searchLabOrderList();
        }
    }, [inputValue, clcikFlagActive, clcikFlagSent, clcikFlagProduction, clcikFlagTransit, clcikFlagRecieved, clcikFlagOverdue, clcikFlagDTL, clcikFlagRTL, clcikFlagToday, clcikFlagTomorrow]);
    const inputValueOnchange = (value) => {
        setInputValue(value)
    }
    const addNewOrder = (mode, data) => {
        console.log("🚀 ~ addNewOrder ~ data:", data)


        setComponentActivate(!componentActivate)
        if (mode === "edit") {
            setEditClick(data)
            const checkbox = document.getElementById(`dropdown-toggle-${data.id}`);
            if (checkbox && checkbox.type === "checkbox") {
                checkbox.checked = false;
            }
        }
        else {
            setEditClick([])
        }

    }
    const searchLabOrderList = () => {
        var statusCheckArray = [clcikFlagActive === true ? "1" : "", clcikFlagSent === true ? "2" : "", clcikFlagProduction === true ? "3" : "", clcikFlagTransit === true ? "4" : "", clcikFlagRecieved === true ? "5" : "", clcikFlagOverdue === true ? "6" : "", clcikFlagDTL === true ? "7" : "", clcikFlagRTL === true ? "8" : ""]
        var statusCheckArrayresult = statusCheckArray.filter(function (value) {
            return value && value !== "";
        }).join(",");
        var dueCheckArray = [clcikFlagToday === true ? "today" : "", clcikFlagTomorrow === true ? "tomarrow" : ""]
        var dueCheckArrayresult = dueCheckArray.filter(function (value) {
            return value && value !== "";
        }).join(",");
        const apiJson = {
            "labOrderId": "",
            "memberId": window.sessionStorage.getItem('memberId'),
            "hospitalId": localStorage.getItem('hospitalId'),
            "doctorId": "",
            "searchInput": inputValue,
            "cmbStatus": statusCheckArrayresult,
            "offset": "",
            "max": "",
            "dueDateSelect": dueCheckArrayresult,
        }
        callingAPI("commonUserFunctions/getDentalLabOrderDetails", apiJson).then((data) => {

            if (data.data.success === "1") {
                setListArray(data.data.result)
                setPageCount(data.data.totalCount)
            }
        })
    }
    const active = (mode) => {
        switch (mode) {
            case 'ACTIVE':
                setClickFlagActive(!clcikFlagActive)
                break;
            case 'SENT':
                setClickFlagSent(!clcikFlagSent)
                break;
            case 'PRODUCTION':
                setClickFlagProduction(!clcikFlagProduction)
                break;
            case 'TRANSIT':
                setClickFlagTransit(!clcikFlagTransit)
                break;
            case 'RECIEVED':
                setClickFlagRecieved(!clcikFlagRecieved)
                break;
            case 'OVERDUE':
                setClickFlagOverdue(!clcikFlagOverdue)
                break;
            case 'DTL':
                setClickFlagDTL(!clcikFlagDTL)
                break;
            case 'RTL':
                setClickFlagRTL(!clcikFlagRTL)
                break;
            case 'TODAY':
                setClickFlagToday(!clcikFlagToday)
                break;
            case 'TOMORROW':
                setClickFlagTomorrow(!clcikFlagTomorrow)
                break;
            default:
                break;
        }
    }
    const statusChange = (data, value) => {
        const apiJson = {
            "id": data.id,
            "dentalLabStatusId": value
        }
        callingAPI("commonUserFunctions/UpdateDentalLabOrderDateAndSatatus", apiJson).then((data) => {

            if (data.data.success === "1") {
                labTrackingList()
            }
        })
    }

    const droplist = (divId, i) => {
        var elementDisplay = document.getElementById(divId + i);
        //elementDisplay.style.display = elementDisplay.style.display === 'block' ? 'none' : 'block';
        elementDisplay.style.display = (dropDownCounter.id === divId + i && dropDownCounter.count === 1) ? 'none' : 'block';
        setDropDownCounter({
            id: divId + i,
            count: (dropDownCounter.id === divId + i && dropDownCounter.count === 1) ? 0 : 1
        })

        document.addEventListener('mouseup', function (e) {
            var container = document.getElementById(divId + i);
            if (container !== null) {
                if (!container.contains(e.target)) {
                    container.style.display = 'none';
                }
            }
        });
    }
    const handleSend = async (labOrderId) => {
        callingAPI('commonUserFunctions/getOrSendPrintprescription', {
            dentalLabOrderId: labOrderId,
            mode: "send"
        }).then((res) => {
            console.log('res222', res);
            // 

            const dropdownElement = document.getElementById(`dropdown${labOrderId}`);
            if (dropdownElement) {
                dropdownElement.style.display = 'none'; // or toggle class to hide it
            }

            // Optional: Uncheck the checkbox if you're using it
            const inputCheckbox = document.querySelector(`#dropdown${labOrderId}`).previousElementSibling;
            if (inputCheckbox && inputCheckbox.type === 'checkbox') {
                inputCheckbox.checked = false;
            }
        });
    }

    const getFieldNameByStatus = (statusId) => {
        const map = {
            1: "onHoldDate",
            2: "dispatchLabDate",
            3: "inProductionDate",
            4: "inTransitDate",
            5: "receivedDate",
            6: "overdueDate",
            7: "deliveredToPatientDate",
            8: "repeatLabDate"
        };
        return map[Number(statusId)];
    };

    const onUpdate = (id, statusId, date) => {
        const fieldName = getFieldNameByStatus(statusId);

        // Convert Date object back to formatted string for controlled component state
        const value = date ? moment(date).format("YYYY-MM-DDTHH:mm") : "";

        setDateField((prev) => {
            const updated = {
                ...prev,
                [`${id}_${fieldName}`]: value,
            };
            console.log("Updated dateField:", updated);
            return updated;
        });

        const timestamp = date ? date.getTime() : null;

        const apiJson = {
            id,
            dentalLabStatusId: statusId,
            onHoldDate: statusId === 1 ? timestamp : '',
            dispatchLabDate: statusId === 2 ? timestamp : '',
            inProductionDate: statusId === 3 ? timestamp : '',
            inTransitDate: statusId === 4 ? timestamp : '',
            receivedDate: statusId === 5 ? timestamp : '',
            overdueDate: statusId === 6 ? timestamp : '',
            deliveredToPatientDate: statusId === 7 ? timestamp : '',
            repeatLabDate: statusId === 8 ? timestamp : ''
        };

        console.log("API JSON", apiJson);

        callingAPI("commonUserFunctions/UpdateDentalLabOrderDateAndSatatus", apiJson).then((data) => {
            if (data.data.success === "1") {
                toast.success("Saved Succcessfully");
                labTrackingList();
                statusList();
            }
        });
    };
    const getDateValue = (id, statusId, fallbackDate) => {
        const fieldName = getFieldNameByStatus(statusId);
        const fieldKey = `${id}_${fieldName}`;

        if (fieldKey in dateField) {
            return new Date(dateField[fieldKey]);
        }

        return fallbackDate ? moment.utc(fallbackDate).local().toDate() : null;
    };

    const getTimeDifferenceLabel = (overdueDate) => {
        const now = moment();
        const due = moment(overdueDate);

        const isFuture = due.isAfter(now); // check if overdue date is in the future
        const start = isFuture ? now.clone() : due.clone();
        const end = isFuture ? due.clone() : now.clone();

        const years = end.diff(start, 'years');
        start.add(years, 'years');

        const months = end.diff(start, 'months');
        start.add(months, 'months');

        const days = end.diff(start, 'days');

        const parts = [];
        if (years > 0) parts.push(`${years} ${years === 1 ? 'year' : 'years'}`);
        if (months > 0) parts.push(`${months} ${months === 1 ? 'month' : 'months'}`);
        if (days > 0) parts.push(`${days} ${days === 1 ? 'day' : 'days'}`);

        const label = parts.join(' ');

        return isFuture ? `- ${label}` : label;
    };



    return (
        <div className="coverWraper labOrderListWrap">
            <Header />
            <div className="contentWraper contentWraperScroll">
                <Leftmenu />
                {componentActivate === false ?
                    <div className="rightSection laborder-wraper">
                        <Profiledetail />
                        <div className="lab-orderheadsectn">
                            <div className='text-mainHead'>LAB TRACKING</div>
                            <div><span className="pl_blue_btn" onClick={(e) => addNewOrder("add")}>+Add New Order</span></div>
                        </div>
                        {/* {listArray && listArray.length > 0 ? */}
                        <div className="list-tablesec">
                            <table className='table mb-0'>
                                <thead>
                                    <tr className='search-section'>
                                        <th className="" colspan="2">
                                            <input type="text" className='inputField input-width' id='autoCompleteValue' placeholder='Search order by Job No./Work Name/Doctor' onChange={(e) => inputValueOnchange(e.target.value)} />
                                        </th>
                                        <th className="text-right" colspan="4">
                                            <div className='div-flex'>
                                                <label htmlFor="" className='label-text'>Status <span style={{ fontWeight: "900", fontSize: "14px", color: "#000" }} >:</span></label>
                                                <span className='statusbar-btns' id='active' onClick={(e) => active("ACTIVE")} style={{ backgroundColor: (clcikFlagActive === true ? '#000' : '#999494') }}>ON HOLD</span>
                                                <span className='statusbar-btns' id='sent' onClick={(e) => active("SENT")} style={{ backgroundColor: (clcikFlagSent === true ? '#000' : '#999494') }}>DISPATCH TO LAB</span>
                                                <span className='statusbar-btns' id='production' onClick={(e) => active("PRODUCTION")} style={{ backgroundColor: (clcikFlagProduction === true ? '#000' : '#999494') }}>IN PRODUCTION</span>
                                                <span className='statusbar-btns' id='transit' onClick={(e) => active("TRANSIT")} style={{ backgroundColor: (clcikFlagTransit === true ? '#000' : '#999494') }}>IN TRANSIT</span>
                                                <span className='statusbar-btns' id='recieved' onClick={(e) => active("RECIEVED")} style={{ backgroundColor: (clcikFlagRecieved === true ? '#000' : '#999494') }}>RECEIVED</span>
                                                <span className='statusbar-btns' id='overdue' onClick={(e) => active("OVERDUE")} style={{ backgroundColor: (clcikFlagOverdue === true ? '#000' : '#999494') }}>OVERDUE</span>
                                                <span className='statusbar-btns' id='drl' onClick={(e) => active("DTL")} style={{ backgroundColor: (clcikFlagDTL === true ? '#000' : '#999494') }}>DELIVERED TO PATIENT</span>
                                                <span className='statusbar-btns' id='trl' onClick={(e) => active("RTL")} style={{ backgroundColor: (clcikFlagRTL === true ? '#000' : '#999494') }}>REPEAT TO LAB</span>
                                            </div>
                                        </th>
                                        <th className="text-right" colspan="2">
                                            <label htmlFor="" className='label-text'>Due <span style={{ fontWeight: "900", fontSize: "14px", color: "#000" }} >:</span></label>
                                            <span className='statusbar-btns' id='today' onClick={(e) => active("TODAY")} style={{ backgroundColor: (clcikFlagToday === true ? '#000' : '#999494') }}>TODAY</span>
                                            <span className='statusbar-btns' id='tomorrow' onClick={(e) => active("TOMORROW")} style={{ backgroundColor: (clcikFlagTomorrow === true ? '#000' : '#999494') }}>TOMORROW</span>
                                        </th>
                                    </tr>
                                </thead>
                            </table>
                            <table className='table mt-0'>
                                <thead>
                                    <tr>
                                        <th style={{ width: '80px' }}>JOB NO.</th>
                                        {/* <th>PATIENT INFO</th> */}
                                        <th>DOCTOR</th>
                                        <th>LAB</th>
                                        <th>WORK NAME</th>
                                        <th>WORK TYPE</th>

                                        <th className=''>STATUS</th>
                                        <th>DATE</th>
                                        {/* <th className='text-right'> {role === "ROLE_DOCTOR" ? "Action" : ""}</th> */}
                                        <th className='text-right'>Action</th>
                                    </tr>
                                </thead>
                                {console.log("🚀 ~ listArray:", listArray)}
                                {console.log("🚀 ~ role:", role)}
                                {listArray && listArray.length > 0 ?

                                    <tbody>
                                        {listArray && listArray.map((list, i) =>
                                            <tr>
                                                <td className='td-textNo'>{list.id}</td>
                                                {/* <td className='td-textName'>{list.patientfirstname + " " + list.patientlastname}</td> */}
                                                <td>{list.doctorName}</td>
                                                <td><span className='icon-phone'><FontAwesomeIcon icon={faPhoneAlt} /></span>{list.dentalLabName}</td>
                                                <td>{list.dentalLabWorkName}</td>
                                                <td>{list.dentalLabWorkTypeName}</td>
                                                {/* <td>{moment(list.dueDate).format("DD-MMM-YYYY")}</td> */}
                                                <td className=''>
                                                    <select value={list.dentalLabStatusId} name="" id="" className='select_status' onChange={(e) => statusChange(list, e.target.value)}>
                                                        {statusListArray.map((obj, i) => (
                                                            <option value={obj.id}>{obj.name}</option>))}
                                                    </select>


                                                </td>

                                                <td style={{ whiteSpace: "nowrap" }}>
                                                    {(() => {
                                                        const statusId = list?.dentalLabStatusId;
                                                        const format = "dd/MM/yyyy h:mm aa";

                                                        if ([2, "2"].includes(statusId)) {
                                                            const fieldName = getFieldNameByStatus(list.dentalLabStatusId);
                                                            const minDateTime = new Date();
                                                            return (
                                                                <Datepicker
                                                                    selected={
                                                                        selectedDates[`${list.id}_${list.dentalLabStatusId}`] ||
                                                                        getDateValue(list.id, list.dentalLabStatusId, list[fieldName])
                                                                    }
                                                                    onChange={(date) => {
                                                                        setSelectedDates((prev) => ({
                                                                            ...prev,
                                                                            [`${list.id}_${list.dentalLabStatusId}`]: date,
                                                                        }));
                                                                    }}
                                                                    onCalendarClose={() => {
                                                                        const key = `${list.id}_${list.dentalLabStatusId}`;
                                                                        const newDate = selectedDates[key];
                                                                        const originalDate = getDateValue(list.id, list.dentalLabStatusId, list[fieldName]);

                                                                        // Only update if user has selected a new date
                                                                        if (
                                                                            newDate &&
                                                                            moment(newDate).format("YYYY-MM-DDTHH:mm") !== moment(originalDate).format("YYYY-MM-DDTHH:mm")
                                                                        ) {
                                                                            onUpdate(list.id, list.dentalLabStatusId, newDate);
                                                                        }
                                                                    }}
                                                                    showTimeSelect
                                                                    timeFormat="HH:mm"
                                                                    timeIntervals={15}
                                                                    dateFormat="dd/MM/yyyy h:mm aa"
                                                                    minDate={minDateTime}
                                                                    onKeyDown={(e) => {
                                                                        if (!["Tab", "Enter", "Escape"].includes(e.key)) e.preventDefault();
                                                                    }}
                                                                    onPaste={(e) => e.preventDefault()}
                                                                    placeholderText="Select date and time"
                                                                />


                                                            );
                                                        }

                                                        if ([8, "8"].includes(statusId)) {
                                                            const fieldName = getFieldNameByStatus(list.dentalLabStatusId);
                                                            const minDateTime = new Date();
                                                            return (
                                                                <Datepicker
                                                                    selected={
                                                                        selectedDates[`${list.id}_${list.dentalLabStatusId}`] ||
                                                                        getDateValue(list.id, list.dentalLabStatusId, list[fieldName])
                                                                    }
                                                                    onChange={(date) => {
                                                                        setSelectedDates((prev) => ({
                                                                            ...prev,
                                                                            [`${list.id}_${list.dentalLabStatusId}`]: date,
                                                                        }));
                                                                    }}
                                                                    onCalendarClose={() => {
                                                                        const key = `${list.id}_${list.dentalLabStatusId}`;
                                                                        const newDate = selectedDates[key];
                                                                        const originalDate = getDateValue(list.id, list.dentalLabStatusId, list[fieldName]);

                                                                        // Only update if user has selected a new date
                                                                        if (
                                                                            newDate &&
                                                                            moment(newDate).format("YYYY-MM-DDTHH:mm") !== moment(originalDate).format("YYYY-MM-DDTHH:mm")
                                                                        ) {
                                                                            onUpdate(list.id, list.dentalLabStatusId, newDate);
                                                                        }
                                                                    }}
                                                                    showTimeSelect
                                                                    timeFormat="HH:mm"
                                                                    timeIntervals={15}
                                                                    dateFormat="dd/MM/yyyy h:mm aa"
                                                                    minDate={minDateTime}
                                                                    onKeyDown={(e) => {
                                                                        if (!["Tab", "Enter", "Escape"].includes(e.key)) e.preventDefault();
                                                                    }}
                                                                    onPaste={(e) => e.preventDefault()}
                                                                    placeholderText="Select date and time"
                                                                />

                                                            );
                                                        }

                                                        if ([1, "1"].includes(statusId)) {
                                                            const fieldName = getFieldNameByStatus(list.dentalLabStatusId);
                                                            const minDateTime = new Date();
                                                            return (
                                                                <Datepicker
                                                                    selected={
                                                                        selectedDates[`${list.id}_${list.dentalLabStatusId}`] ||
                                                                        getDateValue(list.id, list.dentalLabStatusId, list[fieldName])
                                                                    }
                                                                    onChange={(date) => {
                                                                        setSelectedDates((prev) => ({
                                                                            ...prev,
                                                                            [`${list.id}_${list.dentalLabStatusId}`]: date,
                                                                        }));
                                                                    }}
                                                                    onCalendarClose={() => {
                                                                        const key = `${list.id}_${list.dentalLabStatusId}`;
                                                                        const newDate = selectedDates[key];
                                                                        const originalDate = getDateValue(list.id, list.dentalLabStatusId, list[fieldName]);

                                                                        // Only update if user has selected a new date
                                                                        if (
                                                                            newDate &&
                                                                            moment(newDate).format("YYYY-MM-DDTHH:mm") !== moment(originalDate).format("YYYY-MM-DDTHH:mm")
                                                                        ) {
                                                                            onUpdate(list.id, list.dentalLabStatusId, newDate);
                                                                        }
                                                                    }}
                                                                    showTimeSelect
                                                                    timeFormat="HH:mm"
                                                                    timeIntervals={15}
                                                                    dateFormat="dd/MM/yyyy h:mm aa"
                                                                    minDate={minDateTime}
                                                                    onKeyDown={(e) => {
                                                                        if (!["Tab", "Enter", "Escape"].includes(e.key)) e.preventDefault();
                                                                    }}
                                                                    onPaste={(e) => e.preventDefault()}
                                                                    placeholderText="Select date and time"
                                                                />

                                                            );
                                                        }

                                                        if ([7, "7"].includes(statusId)) {
                                                            const fieldName = getFieldNameByStatus(list.dentalLabStatusId);
                                                            const minDateTime = new Date();
                                                            return (
                                                                <Datepicker
                                                                    selected={
                                                                        selectedDates[`${list.id}_${list.dentalLabStatusId}`] ||
                                                                        getDateValue(list.id, list.dentalLabStatusId, list[fieldName])
                                                                    }
                                                                    onChange={(date) => {
                                                                        setSelectedDates((prev) => ({
                                                                            ...prev,
                                                                            [`${list.id}_${list.dentalLabStatusId}`]: date,
                                                                        }));
                                                                    }}
                                                                    onCalendarClose={() => {
                                                                        const key = `${list.id}_${list.dentalLabStatusId}`;
                                                                        const newDate = selectedDates[key];
                                                                        const originalDate = getDateValue(list.id, list.dentalLabStatusId, list[fieldName]);

                                                                        // Only update if user has selected a new date
                                                                        if (
                                                                            newDate &&
                                                                            moment(newDate).format("YYYY-MM-DDTHH:mm") !== moment(originalDate).format("YYYY-MM-DDTHH:mm")
                                                                        ) {
                                                                            onUpdate(list.id, list.dentalLabStatusId, newDate);
                                                                        }
                                                                    }}
                                                                    showTimeSelect
                                                                    timeFormat="HH:mm"
                                                                    timeIntervals={15}
                                                                    dateFormat="dd/MM/yyyy h:mm aa"
                                                                    minDate={minDateTime}
                                                                    onKeyDown={(e) => {
                                                                        if (!["Tab", "Enter", "Escape"].includes(e.key)) e.preventDefault();
                                                                    }}
                                                                    onPaste={(e) => e.preventDefault()}
                                                                    placeholderText="Select date and time"
                                                                />


                                                            );
                                                        }

                                                        if ([3, "3"].includes(statusId)) {
                                                            const fieldName = getFieldNameByStatus(list.dentalLabStatusId);
                                                            const minDateTime = new Date();
                                                            return (
                                                                <Datepicker
                                                                    selected={
                                                                        selectedDates[`${list.id}_${list.dentalLabStatusId}`] ||
                                                                        getDateValue(list.id, list.dentalLabStatusId, list[fieldName])
                                                                    }
                                                                    onChange={(date) => {
                                                                        setSelectedDates((prev) => ({
                                                                            ...prev,
                                                                            [`${list.id}_${list.dentalLabStatusId}`]: date,
                                                                        }));
                                                                    }}
                                                                    onCalendarClose={() => {
                                                                        const key = `${list.id}_${list.dentalLabStatusId}`;
                                                                        const newDate = selectedDates[key];
                                                                        const originalDate = getDateValue(list.id, list.dentalLabStatusId, list[fieldName]);

                                                                        // Only update if user has selected a new date
                                                                        if (
                                                                            newDate &&
                                                                            moment(newDate).format("YYYY-MM-DDTHH:mm") !== moment(originalDate).format("YYYY-MM-DDTHH:mm")
                                                                        ) {
                                                                            onUpdate(list.id, list.dentalLabStatusId, newDate);
                                                                        }
                                                                    }}
                                                                    showTimeSelect
                                                                    timeFormat="HH:mm"
                                                                    timeIntervals={15}
                                                                    dateFormat="dd/MM/yyyy h:mm aa"
                                                                    minDate={minDateTime}
                                                                    onKeyDown={(e) => {
                                                                        if (!["Tab", "Enter", "Escape"].includes(e.key)) e.preventDefault();
                                                                    }}
                                                                    onPaste={(e) => e.preventDefault()}
                                                                    placeholderText="Select date and time"
                                                                />


                                                            );
                                                        }

                                                        if ([4, "4"].includes(statusId)) {
                                                            const fieldName = getFieldNameByStatus(list.dentalLabStatusId);
                                                            const minDateTime = new Date();
                                                            return (
                                                                <Datepicker
                                                                    selected={
                                                                        selectedDates[`${list.id}_${list.dentalLabStatusId}`] ||
                                                                        getDateValue(list.id, list.dentalLabStatusId, list[fieldName])
                                                                    }
                                                                    onChange={(date) => {
                                                                        setSelectedDates((prev) => ({
                                                                            ...prev,
                                                                            [`${list.id}_${list.dentalLabStatusId}`]: date,
                                                                        }));
                                                                    }}
                                                                    onCalendarClose={() => {
                                                                        const key = `${list.id}_${list.dentalLabStatusId}`;
                                                                        const newDate = selectedDates[key];
                                                                        const originalDate = getDateValue(list.id, list.dentalLabStatusId, list[fieldName]);

                                                                        // Only update if user has selected a new date
                                                                        if (
                                                                            newDate &&
                                                                            moment(newDate).format("YYYY-MM-DDTHH:mm") !== moment(originalDate).format("YYYY-MM-DDTHH:mm")
                                                                        ) {
                                                                            onUpdate(list.id, list.dentalLabStatusId, newDate);
                                                                        }
                                                                    }}
                                                                    showTimeSelect
                                                                    timeFormat="HH:mm"
                                                                    timeIntervals={15}
                                                                    dateFormat="dd/MM/yyyy h:mm aa"
                                                                    minDate={minDateTime}
                                                                    onKeyDown={(e) => {
                                                                        if (!["Tab", "Enter", "Escape"].includes(e.key)) e.preventDefault();
                                                                    }}
                                                                    onPaste={(e) => e.preventDefault()}
                                                                    placeholderText="Select date and time"
                                                                />


                                                            );
                                                        }

                                                        if ([5, "5"].includes(statusId)) {
                                                            const fieldName = getFieldNameByStatus(list.dentalLabStatusId);
                                                            const minDateTime = new Date();
                                                            return (
                                                                <Datepicker
                                                                    selected={
                                                                        selectedDates[`${list.id}_${list.dentalLabStatusId}`] ||
                                                                        getDateValue(list.id, list.dentalLabStatusId, list[fieldName])
                                                                    }
                                                                    onChange={(date) => {
                                                                        setSelectedDates((prev) => ({
                                                                            ...prev,
                                                                            [`${list.id}_${list.dentalLabStatusId}`]: date,
                                                                        }));
                                                                    }}
                                                                    onCalendarClose={() => {
                                                                        const key = `${list.id}_${list.dentalLabStatusId}`;
                                                                        const newDate = selectedDates[key];
                                                                        const originalDate = getDateValue(list.id, list.dentalLabStatusId, list[fieldName]);

                                                                        // Only update if user has selected a new date
                                                                        if (
                                                                            newDate &&
                                                                            moment(newDate).format("YYYY-MM-DDTHH:mm") !== moment(originalDate).format("YYYY-MM-DDTHH:mm")
                                                                        ) {
                                                                            onUpdate(list.id, list.dentalLabStatusId, newDate);
                                                                        }
                                                                    }}
                                                                    showTimeSelect
                                                                    timeFormat="HH:mm"
                                                                    timeIntervals={15}
                                                                    dateFormat="dd/MM/yyyy h:mm aa"
                                                                    minDate={minDateTime}
                                                                    onKeyDown={(e) => {
                                                                        if (!["Tab", "Enter", "Escape"].includes(e.key)) e.preventDefault();
                                                                    }}
                                                                    onPaste={(e) => e.preventDefault()}
                                                                    placeholderText="Select date and time"
                                                                />

                                                            );
                                                        }

                                                        if ([6, "6"].includes(statusId)) {
                                                            const overdue = list?.overdueDate;
                                                            const fieldName = getFieldNameByStatus(list.dentalLabStatusId);
                                                            const minDateTime = new Date();
                                                            return (
                                                                <>
                                                                    <Datepicker
                                                                        selected={
                                                                            selectedDates[`${list.id}_${list.dentalLabStatusId}`] ||
                                                                            getDateValue(list.id, list.dentalLabStatusId, list[fieldName])
                                                                        }
                                                                        onChange={(date) => {
                                                                            setSelectedDates((prev) => ({
                                                                                ...prev,
                                                                                [`${list.id}_${list.dentalLabStatusId}`]: date,
                                                                            }));
                                                                        }}
                                                                        onCalendarClose={() => {
                                                                            const key = `${list.id}_${list.dentalLabStatusId}`;
                                                                            const newDate = selectedDates[key];
                                                                            const originalDate = getDateValue(list.id, list.dentalLabStatusId, list[fieldName]);

                                                                            // Only update if user has selected a new date
                                                                            if (
                                                                                newDate &&
                                                                                moment(newDate).format("YYYY-MM-DDTHH:mm") !== moment(originalDate).format("YYYY-MM-DDTHH:mm")
                                                                            ) {
                                                                                onUpdate(list.id, list.dentalLabStatusId, newDate);
                                                                            }
                                                                        }}
                                                                        showTimeSelect
                                                                        timeFormat="HH:mm"
                                                                        timeIntervals={15}
                                                                        dateFormat="dd/MM/yyyy h:mm aa"
                                                                        minDate={minDateTime}
                                                                        onKeyDown={(e) => {
                                                                            if (!["Tab", "Enter", "Escape"].includes(e.key)) e.preventDefault();
                                                                        }}
                                                                        onPaste={(e) => e.preventDefault()}
                                                                        placeholderText="Select date and time"
                                                                    />


                                                                    &nbsp;&nbsp;&nbsp;
                                                                    <span
                                                                        title={getTimeDifferenceLabel(overdue)}
                                                                        style={{
                                                                            display: 'inline-block',
                                                                            maxWidth: '120px',
                                                                            whiteSpace: 'nowrap',
                                                                            overflow: 'hidden',
                                                                            textOverflow: 'ellipsis',
                                                                            verticalAlign: 'bottom',
                                                                            cursor: 'default'
                                                                        }}
                                                                    >
                                                                        {getTimeDifferenceLabel(overdue)}
                                                                    </span>
                                                                </>
                                                            );
                                                        }

                                                        return "";
                                                    })()}
                                                </td>

                                                <td className='text-right'>
                                                    <div className="lab_actions" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px' }}>
                                                        {/* {role === 'ROLE_DOCTOR' && (
                                                            <span
                                                                className='lbListAction'
                                                                onClick={() => addNewOrder("edit", list)}
                                                                style={{ cursor: 'pointer', color: '#007bff' }}
                                                            >
                                                                Edit
                                                            </span>
                                                        )} */}

                                                        <div className="dropdown">
                                                            <div
                                                                className="dd-button"
                                                                onClick={() => droplist("dropdown", list.id)}
                                                                style={{ padding: '15px 9px 5px 15px' }}
                                                            ></div>

                                                            <input
                                                                type="checkbox"
                                                                className="dd-input"
                                                                id={`dropdown-toggle-${list.id}`}
                                                            />

                                                            <ul className="dd-menu" id={"dropdown" + list.id} style={{ "z-index": 10 }}>
                                                                <li>
                                                                    <a
                                                                        className="dropdown-link"
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                        href={`/labOrderListPrint/${list.id}||${localStorage.getItem('hospitalId')}`}
                                                                    >
                                                                        <img
                                                                            src={Printer_icon}
                                                                            alt="Print"
                                                                            title="Print"
                                                                            style={{ width: '15px', marginRight: '6px', verticalAlign: 'middle' }}
                                                                        />
                                                                        Print
                                                                    </a>
                                                                </li>
                                                                <li onClick={() => handleSend(list.id)}>
                                                                    <img
                                                                        src={Send_icon}
                                                                        title="Send"
                                                                        alt="Print"
                                                                        style={{ width: '15px', marginRight: '6px', verticalAlign: 'middle' }}
                                                                    />
                                                                    <span>Send</span>
                                                                </li>
                                                                <li>
                                                                    {role === 'ROLE_DOCTOR' && (
                                                                        <span
                                                                            className=''
                                                                            onClick={() => addNewOrder("edit", list)}
                                                                            style={{ cursor: 'pointer' }}
                                                                        >
                                                                            <img
                                                                                src={Editicon}
                                                                                alt="Print"
                                                                                title='Edit'
                                                                                style={{ width: '15px', marginRight: '6px', verticalAlign: 'middle' }}
                                                                            />
                                                                            <span>Edit</span>
                                                                        </span>
                                                                    )}

                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </td>


                                            </tr>
                                        )}
                                    </tbody>

                                    :
                                    <div className='lbOrderNodata'>
                                        <p><NoLabOrderList /></p>
                                    </div>
                                }
                            </table>
                        </div>

                        {pageCount > 10 && (
                            <div className="paginationSection">
                                <Pagination
                                    activePage={activePage}
                                    itemsCountPerPage={process.env.REACT_APP_PAGINATION_COUNT}
                                    totalItemsCount={pageCount}
                                    pageRangeDisplayed={process.env.REACT_APP_PAGINATION_RANGE}
                                    onChange={paginationOnChange}
                                />
                            </div>
                        )}
                    </div> :
                    <LabOrderSave editClick={editClick} addNewOrder={addNewOrder} labTrackingList={labTrackingList} />}
            </div>
            <Footer />
        </div>
    );

}
export default LabOrderList;
